import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { } from '../../Tonnage/models/TonnageQueryModel';
import FixtureModel from '../../FixtureManagement/models/FixtureModel';
import FixtureSummaryModel from '../models/FixtureSummaryModel';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface myFxtureState {
    fixtures: FixtureModel[],
    summary: FixtureSummaryModel,
    generalNote: string,
    orderColumn: keyof FixtureModel,
    orderDirection: OrderDirection
}

const initialState: myFxtureState = {
    fixtures: [],
    summary: {
        totalTC: 0,
        totalTCT: 0,
        totalCOA: 0,
        totalVoy: 0,
        onGoing: 0,
        outStanding: 0,
        closedFile: 0,
        averagePoint: 0,
    } as FixtureSummaryModel,
    generalNote: "",
    orderColumn: "ref",
    orderDirection: OrderDirection.Desc
}

export const MyFixtureSlice = createSlice({
    name: "MyFixture",
    initialState,
    reducers: {
        setMyFixtures: (state, action: PayloadAction<FixtureModel[]>) => {
            state.fixtures = action.payload;
        },
        setFixtureSummary: (state, action: PayloadAction<FixtureSummaryModel>) => {
            state.summary = action.payload;
        },
        setGeneralNote: (state, action: PayloadAction<string>) => {
            state.generalNote = action.payload;
        },
        setOrderColumn: (state, action: PayloadAction<keyof FixtureModel>) => {
            state.orderColumn = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
    }
});

export const MyFixtureSelector = createSelector(
    (state: RootState) => state.myFixture,
    (data) => data
);

export const {
    setMyFixtures,
    setFixtureSummary,
    setGeneralNote,
    setOrderColumn,
    setOrderDirection
} = MyFixtureSlice.actions;

export default MyFixtureSlice.reducer;